var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 663,
    viewBox: "0 0 599 663",
    width: 599,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7985 45.3987C-126.937 43.6544 -258.221 81.15 -335.92 187.931C-413.595 294.684 -395.254 453.037 -377.87 591.193C-360.467 729.578 -338.869 806.345 -248.188 883.048C-157.804 959.5 -38.3931 1001.87 86.3179 984.828C211.023 967.784 286.737 890.106 379.483 797.495C472.489 704.582 554.905 628.102 560.297 508.52C565.723 389.35 512.288 287.232 407.021 196.656C301.473 105.841 168.713 47.1281 20.7985 45.3987Z",
    fill: "#F1ECE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupVector1);
export default __webpack_public_path__ + "static/media/signup_vector_1.89d690cb8af457ef7fb80a399f762fb0.svg";
export { ForwardRef as ReactComponent };